import React, { Component, createRef } from "react";
import mail from "../assets/imgs/new/mail.png";
import chat from "../assets/imgs/new/chat.png";
import popular from "../assets/imgs/new/popular.png";

import creditCard from "../assets/imgs/dashboard/creditCard.png";
import visa from "../assets/imgs/dashboard/visa.png";
import mastercard from "../assets/imgs/dashboard/mastercard.png";
import mastero from "../assets/imgs/dashboard/mastero.png";
import americanExpress from "../assets/imgs/dashboard/american-express.png";
import paypal from "../assets/imgs/dashboard/paypal.png";

import Logo from "../assets/imgs/new/Logo.png";
import PaymentSuccess from "../assets/imgs/new/paymentSuccess.png";
import firebase from "firebase";

import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";

import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import PhoneComponent from "../components/PhoneComponent";
import { connect } from "react-redux";
import {
  getPackages,
  register,
  registerFree,
  removeVerified,
  signupGoogle,
} from "../redux/actions/auth.action";
import { loadStripe } from "@stripe/stripe-js";
import { MemoraLogoPrimary } from "../assets";
import parsePhoneNumber from "libphonenumber-js";
import { customAlert } from "../redux/actions/alertActions";

const countries = [
  {
    code: "+93",
    name: "Afghanistan",
  },
  {
    code: "+355",
    name: "Albania",
  },
  {
    code: "+213",
    name: "Algeria",
  },
  {
    code: "+376",
    name: "Andorra",
  },
  {
    code: "+244",
    name: "Angola",
  },
  {
    code: "+54",
    name: "Argentina",
  },
  {
    code: "+374",
    name: "Armenia",
  },
  {
    code: "+297",
    name: "Aruba",
  },
  {
    code: "+247",
    name: "Ascension",
  },
  {
    code: "+61",
    name: "Australia",
  },
  {
    code: "+672",
    name: "Australian External Territories",
  },
  {
    code: "+43",
    name: "Austria",
  },
  {
    code: "+994",
    name: "Azerbaijan",
  },
  {
    code: "+973",
    name: "Bahrain",
  },
  {
    code: "+880",
    name: "Bangladesh",
  },
  {
    code: "+375",
    name: "Belarus",
  },
  {
    code: "+32",
    name: "Belgium",
  },
  {
    code: "+501",
    name: "Belize",
  },
  {
    code: "+229",
    name: "Benin",
  },
  {
    code: "+975",
    name: "Bhutan",
  },
  {
    code: "+591",
    name: "Bolivia",
  },
  {
    code: "+387",
    name: "Bosnia and Herzegovina",
  },
  {
    code: "+267",
    name: "Botswana",
  },
  {
    code: "+55",
    name: "Brazil",
  },
  {
    code: "+246",
    name: "British Indian Ocean Territory",
  },
  {
    code: "+673",
    name: "Brunei",
  },
  {
    code: "+359",
    name: "Bulgaria",
  },
  {
    code: "+226",
    name: "Burkina Faso",
  },
  {
    code: "+257",
    name: "Burundi",
  },
  {
    code: "+855",
    name: "Cambodia",
  },
  {
    code: "+237",
    name: "Cameroon",
  },
  {
    code: "+238",
    name: "Cape Verde",
  },
  {
    code: "+345",
    name: "Cayman Islands",
  },
  {
    code: "+236",
    name: "Central African Republic",
  },
  {
    code: "+235",
    name: "Chad",
  },
  {
    code: "+56",
    name: "Chile",
  },
  {
    code: "+86",
    name: "China",
  },
  {
    code: "+61",
    name: "Christmas Island",
  },
  {
    code: "+61",
    name: "Cocos-Keeling Islands",
  },
  {
    code: "+57",
    name: "Colombia",
  },
  {
    code: "+269",
    name: "Comoros",
  },
  {
    code: "+242",
    name: "Congo",
  },
  {
    code: "+243",
    name: "Congo, Dem. Rep. of (Zaire)",
  },
  {
    code: "+682",
    name: "Cook Islands",
  },
  {
    code: "+506",
    name: "Costa Rica",
  },
  {
    code: "+385",
    name: "Croatia",
  },
  {
    code: "+53",
    name: "Cuba",
  },
  {
    code: "+599",
    name: "Curacao",
  },
  {
    code: "+537",
    name: "Cyprus",
  },
  {
    code: "+420",
    name: "Czech Republic",
  },
  {
    code: "+45",
    name: "Denmark",
  },
  {
    code: "+246",
    name: "Diego Garcia",
  },
  {
    code: "+253",
    name: "Djibouti",
  },
  {
    code: "+670",
    name: "East Timor",
  },
  {
    code: "+56",
    name: "Easter Island",
  },
  {
    code: "+593",
    name: "Ecuador",
  },
  {
    code: "+20",
    name: "Egypt",
  },
  {
    code: "+503",
    name: "El Salvador",
  },
  {
    code: "+240",
    name: "Equatorial Guinea",
  },
  {
    code: "+291",
    name: "Eritrea",
  },
  {
    code: "+372",
    name: "Estonia",
  },
  {
    code: "+251",
    name: "Ethiopia",
  },
  {
    code: "+500",
    name: "Falkland Islands",
  },
  {
    code: "+298",
    name: "Faroe Islands",
  },
  {
    code: "+679",
    name: "Fiji",
  },
  {
    code: "+358",
    name: "Finland",
  },
  {
    code: "+33",
    name: "France",
  },
  {
    code: "+596",
    name: "French Antilles",
  },
  {
    code: "+594",
    name: "French Guiana",
  },
  {
    code: "+689",
    name: "French Polynesia",
  },
  {
    code: "+241",
    name: "Gabon",
  },
  {
    code: "+220",
    name: "Gambia",
  },
  {
    code: "+995",
    name: "Georgia",
  },
  {
    code: "+49",
    name: "Germany",
  },
  {
    code: "+233",
    name: "Ghana",
  },
  {
    code: "+350",
    name: "Gibraltar",
  },
  {
    code: "+30",
    name: "Greece",
  },
  {
    code: "+299",
    name: "Greenland",
  },
  {
    code: "+590",
    name: "Guadeloupe",
  },
  {
    code: "+502",
    name: "Guatemala",
  },
  {
    code: "+224",
    name: "Guinea",
  },
  {
    code: "+245",
    name: "Guinea-Bissau",
  },
  {
    code: "+595",
    name: "Guyana",
  },
  {
    code: "+509",
    name: "Haiti",
  },
  {
    code: "+504",
    name: "Honduras",
  },
  {
    code: "+852",
    name: "Hong Kong SAR China",
  },
  {
    code: "+36",
    name: "Hungary",
  },
  {
    code: "+354",
    name: "Iceland",
  },
  {
    code: "+91",
    name: "India",
  },
  {
    code: "+62",
    name: "Indonesia",
  },
  {
    code: "+98",
    name: "Iran",
  },
  {
    code: "+964",
    name: "Iraq",
  },
  {
    code: "+353",
    name: "Ireland",
  },
  {
    code: "+972",
    name: "Israel",
  },
  {
    code: "+39",
    name: "Italy",
  },
  {
    code: "+225",
    name: "Ivory Coast",
  },
  {
    code: "+81",
    name: "Japan",
  },
  {
    code: "+962",
    name: "Jordan",
  },
  {
    code: "+254",
    name: "Kenya",
  },
  {
    code: "+686",
    name: "Kiribati",
  },
  {
    code: "+965",
    name: "Kuwait",
  },
  {
    code: "+996",
    name: "Kyrgyzstan",
  },
  {
    code: "+856",
    name: "Laos",
  },
  {
    code: "+371",
    name: "Latvia",
  },
  {
    code: "+961",
    name: "Lebanon",
  },
  {
    code: "+266",
    name: "Lesotho",
  },
  {
    code: "+231",
    name: "Liberia",
  },
  {
    code: "+218",
    name: "Libya",
  },
  {
    code: "+423",
    name: "Liechtenstein",
  },
  {
    code: "+370",
    name: "Lithuania",
  },
  {
    code: "+352",
    name: "Luxembourg",
  },
  {
    code: "+853",
    name: "Macau SAR China",
  },
  {
    code: "+389",
    name: "Macedonia",
  },
  {
    code: "+261",
    name: "Madagascar",
  },
  {
    code: "+265",
    name: "Malawi",
  },
  {
    code: "+60",
    name: "Malaysia",
  },
  {
    code: "+960",
    name: "Maldives",
  },
  {
    code: "+223",
    name: "Mali",
  },
  {
    code: "+356",
    name: "Malta",
  },
  {
    code: "+692",
    name: "Marshall Islands",
  },
  {
    code: "+596",
    name: "Martinique",
  },
  {
    code: "+222",
    name: "Mauritania",
  },
  {
    code: "+230",
    name: "Mauritius",
  },
  {
    code: "+262",
    name: "Mayotte",
  },
  {
    code: "+52",
    name: "Mexico",
  },
  {
    code: "+691",
    name: "Micronesia",
  },
  {
    code: "+373",
    name: "Moldova",
  },
  {
    code: "+377",
    name: "Monaco",
  },
  {
    code: "+976",
    name: "Mongolia",
  },
  {
    code: "+382",
    name: "Montenegro",
  },
  {
    code: "+1664",
    name: "Montserrat",
  },
  {
    code: "+212",
    name: "Morocco",
  },
  {
    code: "+95",
    name: "Myanmar",
  },
  {
    code: "+264",
    name: "Namibia",
  },
  {
    code: "+674",
    name: "Nauru",
  },
  {
    code: "+977",
    name: "Nepal",
  },
  {
    code: "+31",
    name: "Netherlands",
  },
  {
    code: "+599",
    name: "Netherlands Antilles",
  },
  {
    code: "+687",
    name: "New Caledonia",
  },
  {
    code: "+64",
    name: "New Zealand",
  },
  {
    code: "+505",
    name: "Nicaragua",
  },
  {
    code: "+227",
    name: "Niger",
  },
  {
    code: "+234",
    name: "Nigeria",
  },
  {
    code: "+683",
    name: "Niue",
  },
  {
    code: "+672",
    name: "Norfolk Island",
  },
  {
    code: "+850",
    name: "North Korea",
  },
  {
    code: "+47",
    name: "Norway",
  },
  {
    code: "+968",
    name: "Oman",
  },
  {
    code: "+92",
    name: "Pakistan",
  },
  {
    code: "+680",
    name: "Palau",
  },
  {
    code: "+970",
    name: "Palestinian Territory",
  },
  {
    code: "+507",
    name: "Panama",
  },
  {
    code: "+675",
    name: "Papua New Guinea",
  },
  {
    code: "+595",
    name: "Paraguay",
  },
  {
    code: "+51",
    name: "Peru",
  },
  {
    code: "+63",
    name: "Philippines",
  },
  {
    code: "+48",
    name: "Poland",
  },
  {
    code: "+351",
    name: "Portugal",
  },
  {
    code: "+974",
    name: "Qatar",
  },
  {
    code: "+262",
    name: "Reunion",
  },
  {
    code: "+40",
    name: "Romania",
  },
  {
    code: "+7",
    name: "Russia",
  },
  {
    code: "+250",
    name: "Rwanda",
  },
  {
    code: "+685",
    name: "Samoa",
  },
  {
    code: "+378",
    name: "San Marino",
  },
  {
    code: "+966",
    name: "Saudi Arabia",
  },
  {
    code: "+221",
    name: "Senegal",
  },
  {
    code: "+381",
    name: "Serbia",
  },
  {
    code: "+248",
    name: "Seychelles",
  },
  {
    code: "+232",
    name: "Sierra Leone",
  },
  {
    code: "+65",
    name: "Singapore",
  },
  {
    code: "+421",
    name: "Slovakia",
  },
  {
    code: "+386",
    name: "Slovenia",
  },
  {
    code: "+677",
    name: "Solomon Islands",
  },
  {
    code: "+27",
    name: "South Africa",
  },
  {
    code: "+500",
    name: "South Georgia and the South Sandwich Islands",
  },
  {
    code: "+82",
    name: "South Korea",
  },
  {
    code: "+34",
    name: "Spain",
  },
  {
    code: "+94",
    name: "Sri Lanka",
  },
  {
    code: "+249",
    name: "Sudan",
  },
  {
    code: "+597",
    name: "Suriname",
  },
  {
    code: "+268",
    name: "Swaziland",
  },
  {
    code: "+46",
    name: "Sweden",
  },
  {
    code: "+41",
    name: "Switzerland",
  },
  {
    code: "+963",
    name: "Syria",
  },
  {
    code: "+886",
    name: "Taiwan",
  },
  {
    code: "+992",
    name: "Tajikistan",
  },
  {
    code: "+255",
    name: "Tanzania",
  },
  {
    code: "+66",
    name: "Thailand",
  },
  {
    code: "+670",
    name: "Timor Leste",
  },
  {
    code: "+228",
    name: "Togo",
  },
  {
    code: "+690",
    name: "Tokelau",
  },
  {
    code: "+676",
    name: "Tonga",
  },
  {
    code: "+216",
    name: "Tunisia",
  },
  {
    code: "+90",
    name: "Turkey",
  },
  {
    code: "+993",
    name: "Turkmenistan",
  },
  {
    code: "+688",
    name: "Tuvalu",
  },
  {
    code: "+256",
    name: "Uganda",
  },
  {
    code: "+380",
    name: "Ukraine",
  },
  {
    code: "+971",
    name: "United Arab Emirates",
  },
  {
    code: "+44",
    name: "United Kingdom",
  },
  {
    code: "+1",
    name: "United States",
  },
  {
    code: "+598",
    name: "Uruguay",
  },
  {
    code: "+998",
    name: "Uzbekistan",
  },
  {
    code: "+678",
    name: "Vanuatu",
  },
  {
    code: "+58",
    name: "Venezuela",
  },
  {
    code: "+84",
    name: "Vietnam",
  },
  {
    code: "+681",
    name: "Wallis and Futuna",
  },
  {
    code: "+967",
    name: "Yemen",
  },
  {
    code: "+260",
    name: "Zambia",
  },
  {
    code: "+255",
    name: "Zanzibar",
  },
  {
    code: "+263",
    name: "Zimbabwe",
  },
];

let stripePromise = loadStripe(
  `pk_test_51ISi2nFXnKyMHMzeS9JMGVaj46u104MqmtUONfIyvZNILPvZPgooNVFlPO4Wq3aZXCl8RHkTzP1e6k1s1ju89uNr00mbBy6caY`
);

class Register extends Component {
  state = {
    tab: "sign_up",
    modals: {
      phone: false,
      verification: false,
      verificationMethod: false,
      plan: false,
      payment: false,
      paymentDetail: false,
      confirmedPayment: false,
      forgetPassword: false,
      newPassword: false,
      profile: false,
    },
    formData: {
      title: "",
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirm_password: "",
      receive_relavant_offers: false,
      marketing_purpose: false,
      agree_to_terms: false,
      price_id: "",
      plan_name: "",
      plan_duration: "",
    },
    profile_image: [],
    loginFormData: {
      email: "",
      password: "",
    },
    price_id: "",
    plan_name: "",
    selectedPkg: {},
    loading: false,
    duration: "month",
    paymentPkg: "month",
    sendCode: false,
    plans: [],
  };
  componentDidMount() {
    this.props.getPackages();
  }
  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.auth.verified != this.props.auth.verified &&
      this.props.auth.verified
    ) {
      await this.toggleModal("phone");
      await this.toggleModal("plan");
      this.props.removeVerified();
    }
    if (prevState.plans != this.state.plans) {
      this.setState({
        selectedPkg: this.state.plans[0],
      });
    }
  }
  changeTab = (tab) => {
    this.setState({
      tab,
    });
  };
  handleFormDataChange = (e, value = e.target.value) => {
    // console.log(value, "value");
    let { formData } = this.state;
    let key = typeof e === "string" ? e : e.target.name;
    formData[key] = value;
    this.setState({
      formData,
    });
  };
  signup_ref = createRef(null);
  isAlreadyAcco;
  formValidate = async () => {
    console.log("abc");
    let { formData } = this.state;
    let error = false;
    let error_msg = "";
    let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let snapshots = await firebase
      .firestore()
      .collection("users")
      .where("email", "==", formData.email)
      .get();
    if (formData.agree_to_terms) {
      if (formData.title == "") {
        error = true;
        error_msg = "Title is Required.";
      } else if (formData.firstname == "") {
        error = true;
        error_msg = "Firstname is Required.";
      } else if (formData.lastname == "") {
        error = true;
        error_msg = "Lastname is Required.";
      } else if (formData.email == "") {
        error = true;
        error_msg = "Email is Required.";
      } else if (!formData.email.match(regexEmail)) {
        error = true;
        error_msg = "Bad Email Format.";
      } else if (snapshots.size != 0) {
        error = true;
        error_msg =
          "Email Already Exists! Use another email to create an account.";
      } else if (this.state.profile_image == null) {
        error = true;
        error_msg = "Profile image needed.";
      } else if (formData.password == "") {
        error = true;
        error_msg = "Password is Required.";
      } else if (formData.password.length < 7) {
        error = true;
        error_msg = "Password should be greater than 6 characters";
      } else if (formData.confirm_password == "") {
        error = true;
        error_msg = "Confirm Password is Required.";
      } else if (formData.confirm_password != formData.password) {
        error = true;
        error_msg = "Password not matched.";
      }
    } else {
      error = true;
      error_msg = "You must agree to our Term & Conditions & Privacy Policy.";
    }
    if (error) {
      this.props.customAlert(true, error_msg);
      setTimeout(() => {
        this.props.customAlert(false, "");
      }, 1500);
      // alert(error_msg);
    }
    console.log("Is OK");
    console.log("error:", error);
    return error;
  };
  toggleModal = (name) => {
    let { modals } = JSON.parse(JSON.stringify(this.state));
    for (let modal of Object.keys(modals)) {
      if (modal != name) modals[modal] = false;
    }

    modals[name] = !modals[name];
    this.setState({
      ...this.state,
      modals,
    });
  };
  getCountry = (number) => {
    const phoneNumber = parsePhoneNumber(number);
    let formatted = phoneNumber.formatInternational();
    let country_code = formatted.split(" ")[0];
    let country_data = countries.find(
      (country) => country.code == country_code
    );
    // console.log('checkred', country_data.name)
    // console.log('new res', country_code)
    return country_data.name;
  };
  render() {
    let { auth } = this.props;
    return (
      <>
        <div className="container-fluid pt-3">
          <div className="d-flex align-items-center">
            <h2 className="font-weight-bold text-uppercase">Registration</h2>
          </div>
          <hr />
          <div className="mt-5">
            <h5 className="font-weight-bold">Join Memora</h5>
            <p className="mt-2">
              Your private space to capture life’s most important memories
            </p>
            <div className="mt-3">
              <Row>
                <Col xl="3">
                  <Button
                    className="text-center text-xl-left w-100 btn-outline mr-5 mt-5 google-btn dashboard-btn"
                    size="sm"
                  >
                    <div
                      className="d-block d-xl-flex"
                      onClick={async (e) => {
                        await this.props.signupGoogle(this.props.history);
                      }}
                    >
                      <i className="fa mt-1 fa-google mr-2 "></i>
                      <span>
                        Continue with
                        <br />
                        google
                      </span>
                    </div>
                  </Button>
                </Col>
                {/* <Col xl="3">
                  <Button
                    className="text-center text-xl-left w-100 btn-outline facebook-btn mr-5 mt-5"
                    size="sm"
                  >
                    <div className="d-block d-xl-flex">
                      <i className="fa mt-1 fa-facebook-f mr-2 "></i>
                      <span>
                        Continue with
                        <br />
                        facebook
                      </span>
                    </div>
                  </Button>
                </Col>
                <Col xl="3">
                  <Button
                    className="text-center text-xl-left w-100 btn-outline mr-5 mt-5"
                    size="sm"
                  >
                    <div className="d-block d-xl-flex">
                      <i className="fa mt-1 fa-apple mr-2"></i>
                      <span>
                        Continue with
                        <br />
                        apple
                      </span>
                    </div>
                  </Button>
                </Col> */}
              </Row>
            </div>
            <div className="mt-5">
              <h5 className="font-weight-bold">Sign Up with Email</h5>
              <Form ref={this.signup_ref}>
                <Row>
                  <Col xl="6" lg="8">
                    <Row>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>Title</Label>
                          <Input
                            className="custom-form-control white"
                            type="select"
                            name="title"
                            value={this.state.formData.title}
                            required
                            onChange={(e) => this.handleFormDataChange(e)}
                          >
                            <option
                              className="custom-form-control white"
                              selected=""
                              value=""
                            >
                              Title
                            </option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Ms">Ms</option>
                            <option value="Dr">Dr</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>First Name</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="First Name"
                            value={this.state.formData.firstname}
                            name="firstname"
                            required
                            onChange={(e) => this.handleFormDataChange(e)}
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>Last Name</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="Last Name"
                            value={this.state.formData.lastname}
                            name="lastname"
                            required
                            onChange={(e) => this.handleFormDataChange(e)}
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>Email</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="Email"
                            value={this.state.formData.email}
                            name="email"
                            type="email"
                            required
                            onChange={(e) => this.handleFormDataChange(e)}
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label>Profile</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="Password"
                            name="profile_image"
                            type="file"
                            required
                            onChange={(e) => this.setState({ profile_image: e.target.files[0] })}
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>Password</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="Password"
                            value={this.state.formData.password}
                            name="password"
                            type="password"
                            required
                            onChange={(e) => this.handleFormDataChange(e)}
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" className="mt-3">
                        <FormGroup>
                          <Label>Confirm Password</Label>
                          <Input
                            className="custom-form-control white"
                            placeholder="Confirm Password"
                            value={this.state.formData.confirm_password}
                            name="confirm_password"
                            required
                            type="password"
                            onChange={(e) => this.handleFormDataChange(e)}
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <div className='d-block d-md-flex'>
											<FormGroup check>
												<Label check>
													<Input
														type='checkbox'
														checked={
															this.state.formData
																.receive_relavant_offers
														}
														name='receive_relavant_offers'
														onChange={e => {
															this.handleFormDataChange(
																e,
																e.target.checked
															);
														}}
													/>
													<span
														style={{ fontSize: 12 }}
													>
														Receive relevant offers
														and promotional
														communication from
														Memora
													</span>
												</Label>
											</FormGroup>
											<FormGroup
												check
												className='ml-0 mt-3 mt-md-0 ml-md-3 ml-xl-auto'
											>
												<Label check>
													<Input
														type='checkbox'
														checked={
															this.state.formData
																.marketing_purpose
														}
														name='marketing_purpose'
														onChange={e => {
															this.handleFormDataChange(
																e,
																e.target.checked
															);
														}}
													/>
													<span
														style={{ fontSize: 12 }}
													>
														Marketing Purpose
													</span>
												</Label>
											</FormGroup>
										</div> */}
                    <FormGroup check className=" mt-2">
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={this.state.formData.agree_to_terms}
                          name="agree_to_terms"
                          onChange={(e) => {
                            this.handleFormDataChange(e, e.target.checked);
                          }}
                        />
                        <span style={{ fontSize: 12 }}>
                          By registering you agree to our Terms and Conditions
                          and Privacy Policy
                        </span>
                      </Label>
                    </FormGroup>

                    <Button
                      onClick={async (e) =>
                        localStorage.removeItem("_grecaptcha") ||
                        (!(await this.formValidate()) &&
                          this.toggleModal("phone"))
                      }
                      className="btn-outline mt-5 dashboard-btn"
                    >
                      Sign up
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
        {/* Modals - OK */}
        <Modal
          isOpen={this.state.modals.phone || auth.google_registered}
          size="md"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("phone")}
        >
          <ModalBody>
            <div className="d-flex">
              <span
                className="pointer ml-auto"
                onClick={(e) => this.toggleModal("phone")}
              >
                <i className="fa fa-times" />
              </span>
            </div>
            {(this.state.modals.phone || auth.google_registered) && (
              <PhoneComponent />
            )}
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.verificationMethod}
          size="md"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("verificationMethod")}
        >
          <ModalBody>
            <div className="d-flex">
              <span
                className="pointer ml-auto"
                onClick={(e) => this.toggleModal("verification")}
              >
                <i className="fa fa-times" />
              </span>
            </div>
            <div className="modal-content-wrapper text-center">
              <h5 className="font-weight-bold">Verify your Identity</h5>
              <p>Select a way to recieve the verification code.</p>
              <div className="methods mt-4">
                <a
                  className="method text-left"
                  onClick={(e) => this.toggleModal("verification")}
                >
                  <div className="row">
                    <div className="col-2">
                      <div className="method-icon">
                        <img src={mail} />
                      </div>
                    </div>
                    <div className="col">
                      <p>
                        <small>Email code to</small>
                        <br />
                        <b>{this.state.formData.email}</b>
                      </p>
                    </div>
                  </div>
                </a>
                <hr className="m-0 custom-hr" />
                <a
                  className="method text-left"
                  onClick={(e) => this.toggleModal("verification")}
                >
                  <div className="row">
                    <div className="col-2">
                      <div className="method-icon">
                        <img src={chat} />
                      </div>
                    </div>
                    <div className="col">
                      <p className="mb-0">Text code to number Ending in **03</p>
                      <small>
                        Our text are free, but some service provider may apply
                        usage charge in certain cases{" "}
                      </small>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.verification}
          size="lg"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("verification")}
        >
          <ModalBody>
            <div className="d-flex">
              <span
                className="ml-auto"
                onClick={(e) => this.toggleModal("verification")}
              >
                <i className="fa fa-times" />
              </span>
            </div>
            <div className="modal-content-wrapper text-center">
              <h5 className="font-weight-bold">Verify your Identity</h5>
              <p>Enter the code we have sent to the number end with **03</p>
              <div className="d-flex fields">
                <input type="number" className="custom-number" />
                <input type="number" className="custom-number" />
                <input type="number" className="custom-number" />
                <input type="number" className="custom-number" />
                <input type="number" className="custom-number" />
              </div>
              <div className="d-flex my-5">
                <span className="ml-auto">
                  <a
                    href="#"
                    className="btn-grey"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ sendCode: true });
                    }}
                  >
                    Didn't Receive a code ?
                  </a>
                  <br />
                  <a
                    href=""
                    className="btn-grey d-block mt-4 text-center"
                    onClick={(e) => {
                      e.preventDefault();
                      this.toggleModal("plan");
                    }}
                  >
                    Continue
                  </a>
                </span>
              </div>
              <div className="d-flex flex-column text-left">
                <a
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.toggleModal("verificationMethod");
                  }}
                >
                  Use another method to receive the code
                </a>
                <a
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push("/dashboard/register");
                  }}
                  className="mt-3"
                >
                  Sign in to a different account
                </a>
              </div>
            </div>
          </ModalBody>
          <div
            className={`resend-verification px-4 ${
              this.state.sendCode && "active"
            }`}
          >
            <p>
              Did not receive your code ? Please allow 30 seconds for the
              message to arrive before request another code
            </p>
            <div className="d-flex">
              <div className="resend-btn">
                <i className="fa fa-refresh mr-2"></i>Resend Code
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modals.plan}
          size="xl"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("plan")}
        >
          <ModalBody>
            <div className="d-flex">
              <span
                className="pointer ml-auto"
                onClick={(e) => this.toggleModal("plan")}
              >
                <i className="fa fa-times" />
              </span>
            </div>
            <div className="modal-content-wrapper">
              <h2 className="text-center font-weight-bold">Select Plan</h2>
              {/* <div className="d-flex align-items-center mt-4">
                <Input
                  type="select"
                  value={this.state.duration}
                  onChange={(e) => this.setState({ duration: e.target.value })}
                >
                  <option value="month">Monthly</option>
                  <option value="year">Yearly</option>
                </Input>
              </div> */}
              <div className="row mt-5">
                <Col lg="4" className="mb-4">
                  <Card className="pricing h-100">
                    <CardBody className="p-2">
                      <CardTitle
                        tag="h4"
                        className="text-center font-weight-bold"
                      >
                        Free
                      </CardTitle>
                      <CardSubtitle
                        tag="small"
                        className="mb-4 text-center d-block"
                      >
                        So everyone can capture their story
                      </CardSubtitle>
                      <CardText className="text-left text-center mt-3 font-weight-bold">
                        <h1
                          className="font-weight-bold"
                          style={{
                            lineHeight: "18px",
                          }}
                        >
                          $0
                          <br />
                          <small
                            className="ml-1"
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            per month
                          </small>
                        </h1>
                      </CardText>

                      <ul className="items">
                        <li>10GB Bandwidth Internet</li>
                        <li>Business & Financ Analysing</li>
                        <li>25 Social Media Reviews</li>
                        <li>Customer Managemet</li>
                        <li>24/7 Support</li>
                      </ul>
                      <Button
                        className="btn-outline w-100 d-block dashboard-btn"
                        style={{
                          fontSize: 18,
                          minWidth: "auto",
                        }}
                        disabled={this.state.loading}
                        onClick={async (e) => {
                          e.preventDefault();
                          this.setState({
                            loading: true,
                          });
                          let { formData } = this.state;
                          let country = this.getCountry(this.props.auth.phone);
                          formData["plan_name"] = "free";
                          let password = formData.password;
                          delete formData["password"];
                          if (auth.google_registered) {
                            let obj = {
                              uid: auth.temp_user.id,
                              email: auth.temp_user.email,
                              firstname: auth.temp_user.first_name,
                              lastname: auth.temp_user.last_name,
                              profile_image: auth.temp_user.profile_image,
                              plan_duration: "",
                              plan_name: "free",
                              price_id: "",
                              type: "google",
                            };
                            await this.props.registerFree(
                              {
                                ...obj,
                                phone: this.props.auth.phone,
                                country: country,
                                created_at: firebase.firestore.Timestamp.now(),
                              },
                              password,
                              this.props.history,
                              () => {
                                this.toggleModal("plan");
                              }
                            );
                          } else {
                            await this.props.registerFree(
                              {
                                ...this.state.formData,
                                phone: this.props.auth.phone,
                                country: country,
                                created_at: firebase.firestore.Timestamp.now(),
                              },
                              password,
                              this.props.history,
                              () => {
                                this.toggleModal("plan");
                              }
                            );
                          }
                        }}
                      >
                        {this.state.loading ? (
                          <Spinner size="sm" />
                        ) : (
                          "Get Started"
                        )}
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                {this.props.auth.prices &&
                  this.props.auth.prices
                    .filter(
                      (price) => price.recurring.interval == this.state.duration
                    )
                    .sort((a, b) => a.unit_amount - b.unit_amount)
                    .map((price, idx) => (
                      <Col lg="4" className="mb-4">
                        <Card
                          className={`pricing ${idx == 0 ? "popular" : ""}`}
                        >
                          {idx == 0 && (
                            <div
                              className="popular position-absolute"
                              style={{
                                top: 15,
                                left: -5,
                                height: 30,
                              }}
                            >
                              <img src={popular} />
                              <div
                                className="position-absolute"
                                style={{
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%,-50%)",
                                }}
                              >
                                <small>Popular</small>
                              </div>
                            </div>
                          )}
                          <CardBody className="p-2">
                            <CardTitle
                              tag="h4"
                              className={`text-center font-weight-bold ${
                                idx == 0 ? "mt-5" : ""
                              }`}
                            >
                              {price.nickname.replace(" Yearly", " ")}
                            </CardTitle>
                            <CardSubtitle
                              tag="small"
                              className="mb-4 text-center d-block"
                            >
                              So everyone can capture their story
                            </CardSubtitle>
                            <CardText className="text-left text-center mt-3 font-weight-bold">
                              <h1
                                className="font-weight-bold"
                                style={{
                                  lineHeight: "18px",
                                }}
                              >
                                ${price.unit_amount / 100}
                                <br />
                                <small
                                  className="ml-1"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                >
                                  per month
                                </small>
                              </h1>
                            </CardText>

                            <ul className="items">
                              <li>10GB Bandwidth Internet</li>
                              <li>Business & Financ Analysing</li>
                              <li>25 Social Media Reviews</li>
                              <li>Customer Managemet</li>
                              <li>24/7 Support</li>
                            </ul>
                            <Button
                              className="btn-outline w-100 d-block dashboard-btn"
                              style={{
                                fontSize: 18,
                                minWidth: "auto",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                this.toggleModal("payment");

                                // let { formData } = this.state;
                                // formData.price_id = price.id;
                                // this.setState({ ...formData });

                                let { plans } = this.state;
                                plans = this.props.auth.prices
                                  .filter(
                                    (_price) =>
                                      _price.nickname == price.nickname
                                  )
                                  .sort(
                                    (a, b) => a.unit_amount - b.unit_amount
                                  );
                                this.setState({
                                  plans,
                                });

                                this.handleFormDataChange(
                                  "plan_name",
                                  price.nickname.toLowerCase()
                                );
                              }}
                            >
                              Get Started
                            </Button>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                {/* <Col lg="4">
                  <Card className="pricing position-relative popular">
                    <div
                      className="popular position-absolute"
                      style={{
                        top: 15,
                        left: -5,
                        height: 30,
                      }}
                    >
                      <img src={popular} />
                      <div
                        className="position-absolute"
                        style={{
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%,-50%)",
                        }}
                      >
                        <small>Popular</small>
                      </div>
                    </div>
                    <CardBody className="p-2">
                      <CardTitle
                        tag="h4"
                        className="text-center font-weight-bold mt-5"
                      >
                        Advance Plan
                      </CardTitle>
                      <CardSubtitle
                        tag="small"
                        className="mb-4 text-center d-block"
                      >
                        So everyone can capture their story
                      </CardSubtitle>
                      <CardText className="text-left text-center mt-3 font-weight-bold">
                        <h1
                          className="font-weight-bold"
                          style={{
                            lineHeight: "18px",
                          }}
                        >
                          $39.9
                          <br />
                          <small
                            className="ml-1"
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            per month
                          </small>
                        </h1>
                      </CardText>

                      <ul className="items">
                        <li>10GB Bandwidth Internet</li>
                        <li>Business & Financ Analysing</li>
                        <li>25 Social Media Reviews</li>
                        <li>Customer Managemet</li>
                        <li>24/7 Support</li>
                      </ul>
                      <Button
                        className="btn-outline"
                        style={{
                          fontSize: 18,
                          minWidth: "auto",
                          width: "100%",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleModal("payment");
                        }}
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="pricing">
                    <CardBody className="p-2">
                      <CardTitle
                        tag="h4"
                        className="text-center font-weight-bold"
                      >
                        Premium Plan
                      </CardTitle>
                      <CardSubtitle
                        tag="small"
                        className="mb-4 text-center d-block"
                      >
                        So everyone can capture their story
                      </CardSubtitle>
                      <CardText className="text-left text-center mt-3 font-weight-bold">
                        <h1
                          className="font-weight-bold"
                          style={{
                            lineHeight: "18px",
                          }}
                        >
                          $99.9
                          <br />
                          <small
                            className="ml-1"
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            per month
                          </small>
                        </h1>
                      </CardText>
                      <ul className="items">
                        <li>10GB Bandwidth Internet</li>
                        <li>Business & Financ Analysing</li>
                        <li>25 Social Media Reviews</li>
                        <li>Customer Managemet</li>
                        <li>24/7 Support</li>
                      </ul>
                      <Button
                        className="btn-outline"
                        style={{ fontSize: 18 }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleModal("payment");
                        }}
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col> */}
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.payment}
          size="lg"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("payment")}
        >
          <ModalBody>
            <div className="d-flex">
              <span
                className="pointer ml-auto"
                onClick={(e) => this.toggleModal("payment")}
              >
                <i className="fa fa-times" />
              </span>
            </div>
            <div className="modal-content-wrapper">
              <h2 className="text-center font-weight-bold">
                Choose Payment Plan
              </h2>
              <div className="row justify-content-center">
                <div className="col-xl-10">
                  <div className="row mt-4">
                    {this.state.plans.map((plan) => (
                      <div className="col-6">
                        <div
                          className={`card custom-card-modal text-center image-icon ${
                            this.state.paymentPkg == plan.recurring.interval
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            this.setState({
                              paymentPkg: plan.recurring.interval,
                              selectedPkg: plan,
                              price_id: plan.id,
                              duration: plan.recurring.interval.toLowerCase(),
                            });
                            this.handleFormDataChange("price_id", plan.id);
                            this.handleFormDataChange(
                              "plan_duration",
                              plan.recurring.interval.toLowerCase()
                            );
                          }}
                        >
                          <div className="card-body">
                            <p className="m-0 mb-3 text-uppercase">
                              {plan.recurring.interval}
                              ly
                            </p>
                            <div className="d-flex justify-content-center modal-icon">
                              {/* <img
                                                    src={calendar1}
                                                    style={{ maxHeight: 50 }}
                                                /> */}
                              <svg
                                width="110"
                                height="110"
                                viewBox="0 0 110 110"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M110 85.4698L109.278 82.0686L93.843 9.5812L93.0471 5.85285L89.3449 6.76397L84.5602 7.93851C83.7376 5.79033 82.4437 3.88333 80.5838 2.53102C78.8191 1.24655 76.6774 1.1544 74.9888 2.60509C73.0421 4.27682 72.8453 7.51806 72.9067 10.098C72.9138 10.3406 72.9212 10.57 72.9283 10.799L69.7528 11.5803C69.6574 11.3332 69.522 11.1075 69.4121 10.8666C68.5857 9.04342 67.4275 7.4105 65.8002 6.22796C64.0354 4.94409 61.8937 4.85135 60.2051 6.30174C58.3719 7.87955 58.0922 10.8503 58.1177 13.3481C58.123 13.671 58.1266 13.986 58.1372 14.29C58.1411 14.3407 58.1411 14.3866 58.1443 14.4361L54.9464 15.2237C54.9164 15.1514 54.8761 15.0847 54.8471 15.0124C54.7244 14.7185 54.5775 14.4397 54.4385 14.1573C53.6237 12.5018 52.528 11.0177 51.0222 9.92462C49.2559 8.64074 47.1134 8.548 45.4262 9.99869C43.7023 11.4817 43.3477 14.2017 43.3326 16.5976C43.3308 16.9215 43.337 17.2335 43.3459 17.5422C43.3515 17.7253 43.3551 17.8987 43.3622 18.0744L40.1399 18.8664C40.0623 18.6723 39.9577 18.4957 39.8729 18.3052C39.7432 18.0148 39.6122 17.7268 39.4643 17.4498C38.6679 15.9588 37.6258 14.6281 36.2421 13.623C34.4758 12.3395 32.3333 12.2464 30.6461 13.6971C29.0295 15.088 28.6227 17.5636 28.5676 19.8442C28.5605 20.1672 28.5566 20.4792 28.5605 20.7915C28.564 21.107 28.5694 21.414 28.5803 21.7115L27.745 21.9171L25.3086 22.4531C25.1886 22.1571 25.0389 21.8818 24.9008 21.5968C24.7619 21.3127 24.649 21.0131 24.4923 20.7396C23.7219 19.4092 22.726 18.2344 21.4638 17.3179C19.6975 16.034 17.555 15.9413 15.8681 17.392C14.357 18.691 13.9042 20.9372 13.8041 23.086C13.7896 23.4072 13.7771 23.7248 13.7741 24.0395C13.7724 24.3607 13.7786 24.6766 13.7878 24.9832L6.63774 26.5536L0 93.731L23.1085 86.9582L23.3044 87.8565L23.4949 88.7606L23.7699 90.0667L5.05845 95.9974L0.0868162 97.5758L4.94201 99.4813L27.2449 108.232L27.6274 108.382L27.6313 108.4L27.6573 108.393L27.8215 108.458L28.4188 108.292L73.4794 95.6745L75.2403 95.182L75.2332 95.1461L106.656 86.399L110 85.4698ZM77.4661 5.35417C77.643 5.15298 77.6537 5.17728 77.7296 5.1918C78.1986 5.28187 78.5921 5.60573 79.0629 6.06796C79.7394 6.73642 80.27 7.5311 80.7047 8.388C80.7806 8.53793 80.86 8.68045 80.9284 8.83364L76.5858 9.90091C76.5787 9.70328 76.5787 9.49854 76.5787 9.29379C76.5749 7.80399 76.7298 6.20396 77.4661 5.35417ZM62.7797 9.04905C62.9527 8.84786 62.9169 8.87216 62.9924 8.88667C63.4618 8.97705 63.8333 9.30061 64.3024 9.76284C64.8728 10.324 65.3092 10.986 65.706 11.6843C65.8541 11.9442 66.0091 12.1975 66.132 12.4728L63.9599 13.0512L62.177 13.5356C62.177 13.5185 62.177 13.5004 62.177 13.4835C62.177 13.1747 61.9841 12.8574 61.9894 12.538C62.022 11.1854 62.1157 9.8141 62.7797 9.04905ZM47.0414 15.7795C47.1036 14.5825 47.3184 13.4242 47.9057 12.7439C48.0817 12.5427 48.0923 12.567 48.1682 12.5815C48.6372 12.6719 49.0307 12.9955 49.5007 13.4577C49.9626 13.9125 50.3451 14.4331 50.6906 14.9795C50.8622 15.2509 51.0228 15.5306 51.1668 15.8201C51.2162 15.9203 51.2796 16.0106 51.3256 16.1126L47.0224 17.1707C47.0188 17.0264 47.0188 16.8794 47.0188 16.733C47.0171 16.4157 47.0245 16.0975 47.0414 15.7795ZM33.1715 16.4391C33.3472 16.2379 33.3365 16.2622 33.4124 16.2767C33.8814 16.3671 34.264 16.6907 34.7312 17.1526C35.0821 17.4984 35.3834 17.8806 35.6658 18.2812C35.8524 18.5455 36.0041 18.8344 36.163 19.1185C36.283 19.3304 36.4184 19.5325 36.523 19.7535C36.5327 19.7743 36.5401 19.7959 36.5473 19.8184L32.6177 20.8036C32.6177 20.5319 32.4239 20.256 32.4293 19.9754C32.4346 19.6543 32.3608 19.334 32.3887 19.0184C32.4823 17.9899 32.6601 17.0311 33.1715 16.4391ZM17.4794 23.2176C17.4957 22.891 17.5218 22.5672 17.5641 22.2534C17.6806 21.4036 17.9096 20.6368 18.3455 20.1343C18.5215 19.9331 18.5322 19.9574 18.608 19.9719C19.077 20.0623 19.4705 20.3858 19.9405 20.8478C20.1731 21.0768 20.3618 21.3432 20.5645 21.5956C20.7731 21.8581 20.9769 22.126 21.1553 22.4119C21.326 22.6863 21.4883 22.963 21.6326 23.2528L17.4604 24.1693C17.4569 23.8534 17.4622 23.5379 17.4794 23.2176ZM74.2726 91.5861L73.3831 91.8332L72.4936 92.0803L30.4408 103.793L27.6976 90.7665L27.5056 89.8607L27.3136 88.9517L27.0547 87.7247L26.8653 86.8174L26.6748 85.9116L14.6693 28.938L22.7521 26.9442C23.0641 29.0337 22.9533 31.205 22.5248 33.0687C21.9906 35.3881 25.5521 36.3722 26.0881 34.0518C26.6502 31.6136 26.7504 28.788 26.3029 26.0727L37.5413 23.3085C37.8427 25.3797 37.7319 27.5258 37.3067 29.3735C36.7727 31.693 40.3343 32.677 40.87 30.3567C41.4282 27.9347 41.5304 25.1317 41.0937 22.4362L52.3286 19.6738C52.6189 21.7272 52.5078 23.8517 52.0868 25.6801C51.5528 27.9996 55.1144 28.9836 55.6501 26.6636C56.2048 24.2576 56.3088 21.4789 55.8827 18.8024L67.1166 16.04C67.3981 18.0744 67.2861 20.1746 66.8678 21.9867C66.3335 24.3059 69.8971 25.2902 70.4328 22.9699C70.9849 20.5829 71.0894 17.8261 70.6743 15.1656L80.1284 12.8417L81.0775 12.6091L81.9038 12.4052C81.929 12.6002 81.9542 12.7916 81.9723 12.9881C82.1492 14.8186 82.0227 16.6717 81.6472 18.2933C81.1133 20.6128 84.6766 21.5968 85.2123 19.2768C85.7611 16.9061 85.8654 14.1736 85.4651 11.532L90.2355 10.3584L105.673 82.8443L74.2726 91.5861ZM41.8777 71.1638L30.6041 73.8664L27.8985 62.5918L39.1722 59.8875L41.8777 71.1638ZM44.2511 70.4494L41.5467 59.1746L52.8204 56.4703L55.5248 67.743L44.2511 70.4494ZM55.1884 55.7523L66.4603 53.0459L69.1668 64.319L57.8937 67.0251L55.1884 55.7523ZM80.1074 49.6304L82.8138 60.9032L77.7835 62.1104L76.8383 62.3376L75.8892 62.5652L71.5375 63.6082L68.8346 52.3333L76.9248 50.391L77.8739 50.1647L78.8191 49.9374L80.1074 49.6304ZM82.4801 48.917L93.7547 46.2123L96.4593 57.486L85.1848 60.1906L82.4801 48.917ZM54.3558 53.4157L51.6503 42.142L62.924 39.4377L65.6304 50.7113L54.3558 53.4157ZM67.994 49.994L65.2911 38.7203L76.5678 36.0157L77.7367 40.8934L78.4188 43.7459L79.1044 46.5984L79.2703 47.2894L79.0395 47.3445L78.0943 47.5717L77.1491 47.799L67.994 49.994ZM90.2112 32.5958L92.9159 43.8695L81.641 46.5738L79.7684 38.7743L79.0863 35.9209L78.9346 35.3001L79.1441 35.2507L80.0893 35.0234L90.2112 32.5958ZM45.2843 84.2174L45.4197 84.7803L37.5858 86.6586L34.146 87.4829L33.989 86.8281L33.7318 85.7602L33.5152 84.8636L33.2995 83.9652L31.4402 76.2104L42.7139 73.5061L44.4395 80.7012L44.6558 81.5978L44.8715 82.4979L45.0674 83.319L45.2843 84.2174ZM58.9438 80.8579L59.0629 81.3581L52.066 83.0375L47.7874 84.0624L47.6449 83.4707L47.4292 82.5688L47.2461 81.7999L47.0295 80.9015L46.8138 80.0049L45.0861 72.7882L56.3618 70.0856L57.9547 76.7358L58.1713 77.6342L58.3876 78.5308L58.5103 79.054L58.7266 79.9542L58.9438 80.8579ZM71.9037 74.5719L72.7135 77.937L70.6948 78.4223L69.7982 78.6371L68.8998 78.8534L61.4374 80.6431L61.3109 80.1092L61.0946 79.2069L60.8783 78.3103L60.7663 77.8374L60.55 76.939L60.337 76.0406L58.7367 69.3703L70.0094 66.666L71.4764 72.7766L71.6912 73.6753L71.9037 74.5719Z" />
                              </svg>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                              <input
                                type="radio"
                                name="payment"
                                value="yearly"
                                checked={
                                  this.state.paymentPkg ==
                                  plan.recurring.interval
                                }
                                className="mr-2"
                              />
                              <h2 className="mt-3 mb-0 font-weight-bold">
                                ${plan.unit_amount / 100}
                              </h2>
                            </div>
                            <small>per year AUD</small>
                            <br />
                            <small className="mt-4 d-inline-block">
                              ${plan.unit_amount / 100} AUD charged{" "}
                              {plan.recurring.interval}
                              ly
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <small className="mt-5 d-inline-block">
                    Save 2 months with a yearly subscription
                  </small>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  className="btn btn-primary btn-outline dashboard-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.toggleModal("paymentDetail");
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.paymentDetail}
          size="lg"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("paymentDetail")}
        >
          <ModalBody>
            <div className="modal-content-wrapper">
              <div className="d-flex mb-4">
                <img src={MemoraLogoPrimary} height="30px" />
                <span
                  className="pointer ml-auto"
                  onClick={(e) => this.toggleModal("paymentDetail")}
                >
                  <i className="fa fa-times" />
                </span>
              </div>
              <div className="d-flex mt-3">
                <h5 className="font-weight-bold">Memora Plus Annual Plan...</h5>
                <h4 className="font-weight-bold ml-auto">
                  ${Number(this.state.selectedPkg.unit_amount) / 100}
                </h4>
              </div>
              <p className="text-uppercase" style={{ letterSpacing: "2px" }}>
                You will be charged after 90-day trial
              </p>
              <div className="payment-icons mb-2 d-flex mt-4 align-items-center">
                <img src={creditCard} className="mr-2" />
                <h6 className="font-weight-bold">Payment</h6>
                <div className="payment-accepted d-flex align-items-center">
                  <img src={visa} />
                  <img src={mastercard} />
                  <img src={mastero} />
                  <img src={americanExpress} />
                  <img src={paypal} />
                </div>
              </div>
              <hr className="m-0" style={{ borderTop: "6px solid #707070" }} />
              <Elements stripe={stripePromise}>
                <ElementsConsumer>
                  {({ elements, stripe }) => (
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        this.setState({
                          loading: true,
                        });
                        const cardElement = await elements.getElement(
                          CardNumberElement
                        );
                        const cardElement2 = await elements.getElement(
                          CardExpiryElement
                        );
                        const cardElement3 = await elements.getElement(
                          CardCvcElement
                        );

                        const { error, paymentMethod } =
                          await stripe.createPaymentMethod({
                            type: "card",
                            card: cardElement,
                            billing_details: {
                              email: auth.temp_user
                                ? auth.temp_user.email
                                : this.state.formData.email,
                              name: auth.temp_user
                                ? auth.temp_user.first_name +
                                  " " +
                                  auth.temp_user.last_name
                                : this.state.formData.firstname +
                                  " " +
                                  this.state.formData.lastname,
                            },
                          });

                        if (error) {
                          this.props.customAlert(true, error.message);
                          setTimeout(() => {
                            this.props.customAlert(false, "");
                          }, 1500);
                          // alert(
                          // 	error.message,
                          // 	'danger'
                          // );
                          this.setState({
                            loading: false,
                          });
                        } else {
                          console.log("[PaymentMethod]", paymentMethod);
                          const result = await stripe.createToken(cardElement);
                          console.log(result);
                          if (result.error) {
                            this.props.customAlert(true, result.error.message);
                            setTimeout(() => {
                              this.props.customAlert(false, "");
                            }, 1500);
                            // alert(
                            // 	result.error
                            // 		.message,
                            // 	'danger'
                            // );
                            console.log(result);
                            return;
                          } else {
                            let { formData } = this.state;
                            let country = this.getCountry(
                              this.props.auth.phone
                            );
                            let password = formData.password;
                            delete formData["password"];
                            if (auth.google_registered) {
                              let obj = {
                                uid: auth.temp_user.id,
                                email: auth.temp_user.email,
                                firstname: auth.temp_user.first_name,
                                lastname: auth.temp_user.last_name,
                                profile_image: auth.temp_user.profile_image,
                                plan_duration: this.state.duration,
                                plan_name: this.state.selectedPkg.nickname,
                                price_id: this.state.price_id,
                                type: "google",
                              };
                              await this.props.register(
                                {
                                  ...obj,
                                  phone: this.props.auth.phone,
                                  country: country,
                                  created_at:
                                    firebase.firestore.Timestamp.now(),
                                },
                                password,
                                result.token.id,
                                this.props.history,
                                Number(this.state.selectedPkg.unit_amount),
                                () => {
                                  this.toggleModal("paymentDetail");
                                }
                              );
                            } else {
                              await this.props.register(
                                {
                                  ...this.state.formData,
                                  phone: this.props.auth.phone,
                                  country: country,
                                  created_at:
                                    firebase.firestore.Timestamp.now(),
                                },
                                password,
                                result.token.id,
                                this.props.history,
                                Number(this.state.selectedPkg.unit_amount),
                                () => {
                                  this.toggleModal("paymentDetail");
                                }
                              );
                            }
                          }
                        }
                      }}
                    >
                      <div className="row mt-2">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Card Number</label>
                            <CardNumberElement />{" "}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>MM/YY</label>
                            <CardExpiryElement />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>CVC Code</label>
                            <CardCvcElement />{" "}
                          </div>
                        </div>
                      </div>
                      <small className="mt-4">
                        I authorize Memora Group Ltd to save this payment method
                        and automatically charge this payment method whenever a
                        subscription is associated with it.
                      </small>
                      <div className="text-center">
                        <button
                          className="btn btn-primary mx-auto mt-3 btn-outline dashboard-btn"
                          type="submit"
                          disabled={this.state.loading}
                          // onClick={(e) => {
                          //   e.preventDefault();
                          //   this.toggleModal("confirmedPayment");
                          // }}
                        >
                          {this.state.loading ? (
                            <Spinner size="sm" />
                          ) : (
                            "Subscribe"
                          )}
                        </button>
                      </div>
                    </form>
                  )}
                </ElementsConsumer>
              </Elements>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.confirmedPayment}
          size="md"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("confirmedPayment")}
        >
          <ModalBody>
            <div className="modal-content-wrapper text-center">
              <img src={PaymentSuccess} width="120px" />
              <h4
                className="mt-5 d-block text-center font-weight-bold"
                style={{ letterSpacing: "3px" }}
              >
                Your Payment has been confirmed
              </h4>
              {/* <div className="d-flex justify-content-center mt-4">
                <button
                  className="btn btn-primary btn-outline"
                  onClick={(e) => {
                    e.preventDefault();
                    this.toggleModal("confirmedPayment");
                  }}
                >
                  Close
                </button>
              </div> */}
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  console.log("state:", state);
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getPackages: () => dispatch(getPackages()),
    register: (credentails, password, token, _history, amount) =>
      dispatch(register(credentails, password, token, _history, amount)),
    register: (credentails, password, token, _history, amount, onSuccess) =>
      dispatch(
        register(credentails, password, token, _history, amount, onSuccess)
      ),
    registerFree: (credentails, password, _history, onSuccess) =>
      dispatch(registerFree(credentails, password, _history, onSuccess)),
    removeVerified: () => dispatch(removeVerified()),
    signupGoogle: (router) => dispatch(signupGoogle(router)),
    customAlert: (val, message) => dispatch(customAlert(val, message)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
